module.exports = __webpack_public_path__ + "media/images/artificial-intelligence-45975571f2e0d2d520a2d4492771f390.png";